import React from "react";
import { Navigate } from "react-router-dom";

const Invoices = React.lazy(() => import("./Console/Routes/Invoices"));
const AddedSubjects = React.lazy(() => import("./Console/Routes/AddedSubjects"));
const WatchedSubjects = React.lazy(() => import("./Console/Routes/WatchedSubjects"));
const Credits = React.lazy(() => import("./Console/Routes/Credits"));
const AddSubject = React.lazy(() => import("./Console/Routes/AddSubject"));
const NotificationsPage = React.lazy(() => import("./Console/Routes/NotificationsPage"));
const EventsSubject = React.lazy(() => import("./Console/Routes/EventsSubject"));
const MainPage = React.lazy(() => import("./Public/Routes/MainPage"));
const NotificationPage = React.lazy(() => import("./Public/Routes/NotificationPage"));
const AppPage = React.lazy(() => import("./Public/Routes/AppPage"));
const InfoPage = React.lazy(() => import("./Public/Routes/InfoPage"));
const ApiPage = React.lazy(() => import("./Public/Routes/ApiPage"));
const Cookies = React.lazy(() => import("../Pages/Cookies"));
const Verify = React.lazy(() => import("./Console/Routes/Verify"));
const VerifyDone = React.lazy(() => import("./Console/Routes/VerifyDone"));
const PasswordReset = React.lazy(() => import("./Console/Routes/PasswordReset"));
const PaymentRedirect = React.lazy(() => import("./Console/Routes/PaymentRedirect"));

const Login = React.lazy(() => import("./Console/Routes/Login"));
const Register = React.lazy(() => import("./Console/Routes/Register"));
const Settings = React.lazy(() => import("./Console/Routes/Settings"));

const ObchodniPodminky = React.lazy(() => import("../Pages/ObchodniPodminky"));
const OchranaUdaju = React.lazy(() => import("../Pages/OchranaUdaju"));

//const CompName = React.lazy(() => const("CompName"));

const noAuthRoutes = ['/login', '/register', '/auth/action', '/reset'];
const verifyRoutes = ['/verify', '/auth/action'];
const noSidebarRoutes = ['/login', '/register', '/verify', '/auth/action', '/reset'];

export const isAdBannerRoute = (pathname) => {
  return !(isNoSidebarRoute(pathname) || isVerifyRoute(pathname));
}

export const isNoSidebarRoute = (pathname) => {
  return noSidebarRoutes.includes(pathname);
}

export const isNoAuthRoute = (pathname) => {
  return noAuthRoutes.includes(pathname);
}

export const isVerifyRoute = (pathname) => {
  return verifyRoutes.includes(pathname);
}

export const consoleRoutes = [
  {
    path: "*",
    element: <div></div>,
  },
  {
    path: "/login",
    element: (
      <Login />
    ),
  },
  {
    path: "/register",
    element: (
      <Register />
    ),
  },
  {
    path: "/reset",
    element: (
      <PasswordReset />
    ),
  },
  {
    path: "/verify",
    element: (
      <Verify />
    ),
  },
  {
    path: "/auth/action",
    element: (
      <VerifyDone />
    ),
  },
  {
    path: "/settings",
    element: (
      <Settings />
    ),
  },
  {
    path: "/list_added",
    element: (
      <AddedSubjects />
    ),
  },
  {
    path: "/list_watched",
    element: (
      <WatchedSubjects />
    ),
  },
  {
    path: "/credit",
    element: (
      <Credits />
    ),
  },
  {
    path: "/add",
    element: (
      <AddSubject />
    ),
  },
  {
    path: "/notifications",
    element: (
      <NotificationsPage />
    ),
  },
  {
    path: "/events",
    element: (
      <EventsSubject />
    ),
  },
  {
    path: "/redirect",
    element: (
      <PaymentRedirect />
    ),
  },
  {
    path: "/invoices",
    element: (
      <Invoices />
    ),
  },
];

export const baseRoutes = [
  {
    path: "*",
    element: <Navigate to="/" />,
  },
  {
    path: "/",
    element: (
      <MainPage />
    ),
  },
  {
    path: "/notifikace",
    element: (
      <NotificationPage />
    ),
  },
  {
    path: "/aplikace",
    element: (
      <AppPage />
    ),
  },
  {
    path: "/informace",
    element: (
      <InfoPage />
    ),
  },
  {
    path: "/apipage",
    element: (
      <ApiPage />
    ),
  },
  {
    path: "/podminky",
    element: (
      <ObchodniPodminky />
    ),
  },
  {
    path: "/soukromi",
    element: (
      <OchranaUdaju />
    ),
  },
  {
    path: "/cookies",
    element: (
      <Cookies />
    ),
  },
];

